import getEnvironment from "../getEnvironment";

const isDevMode = (): boolean =>
  getEnvironment() === "localhost" && !process.env.VIRTUAL_DOMAIN;

  const getBuyerAPIDomain = (isToUseAuthZero = false): URL => {
    if (isDevMode()) {
      return new URL("api", "https://cms.uat.britishcarauctions.net");
  }
  if (typeof process.env.VIRTUAL_DOMAIN === "string") {
    if (isToUseAuthZero) {
      return new URL("api", process.env.VIRTUAL_DOMAIN);
    }
    const buyerAPIDomainUrl = new URL(
      `${process.env.URL_SUFFIX}/api`,
      `${process.env.VIRTUAL_DOMAIN}`
    );

    return buyerAPIDomainUrl;
  }

  return null;
};

export default getBuyerAPIDomain;
